<template>
  <div class="input-container" :class="{ full: full }" :style="{ width: width + 'px', height: height + 'px' }">
    <div class="label">{{label}}</div>
    <textarea 
      :placeholder="placeholder"
      :type="type"
      :disabled="disabled"
      :readonly="readonly"
      :class="{ error: error, readonly: readonly }"
      :style="{ textAlign: alignRight ? 'right' : '' }"
      v-model="inputValue"
    />
    <!-- <div class="error-message" v-if="error"><h3>에러 메세지</h3></div> -->
  </div>
</template>

<script>
export default {
  name: 'InputTextAreaComp',
  components: {
  },
  props: {
    label: String,
    full: Boolean,
    value: String,
    password: Boolean,
    width: [String, Number],
    height: [String, Number],
    alignRight: Boolean,
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disableDeleteBtn: Boolean,
  },

  data() {
    return {
      inputValue: this.value,
    };
  },

  mounted() {},

  methods: {
    clearInput: function () {
      this.inputValue = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.input-container {
  position: relative;
  /* height: 50px; */
  width: 100%;
  textarea {
    width: 100%;
    height: 160px;
    border: 1px solid #BBBBBB;
    font-size: 16px;
    padding: 15px;
    &:hover {
      border-color: var(--main-orange);
    }
    &:focus {
      border-color: var(--main-orange);
    }
    &::placeholder {
      color: #BBBBBB;
    }
  }
  .label {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 9px;
  }
  /* @media (max-width: $mobile) {
      .label {
        font-size: 14px;
      }
      textarea {
        font-size: 14px;
      }
    } */
}
</style>
